<template>
  <div class="main">
    <main-tab-bar/>
  </div>
</template>

<script>
import MainTabBar from '../../components/MainTabBar.vue';
export default {
  components: { MainTabBar },
  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
}
</style>